import React from 'react';
import './Landing.css';

export default function Terms() {
  return (
    <div className="landing">
      <section className="hero" style={{ paddingBottom: '2rem' }}>
        <h1 className="landing-title" style={{ fontSize: '2.5rem' }}>Terms of Service</h1>
      </section>

      <section style={{ maxWidth: '600px', margin: '0 auto', lineHeight: '1.8', color: '#6D6056' }}>
        <p><strong style={{ color: '#5D4037' }}>Effective Date:</strong> February 27, 2026</p>

        <p>By using String App ("String," "the Service"), you agree to the following terms.</p>

        <h2 style={{ color: '#5D4037', fontSize: '1.15rem', marginTop: '2rem' }}>Service Description</h2>
        <p>String is a personal event reminder service that helps you remember birthdays and anniversaries for the people you care about. Reminders are delivered via SMS and/or email based on your preferences.</p>

        <h2 style={{ color: '#5D4037', fontSize: '1.15rem', marginTop: '2rem' }}>SMS Messaging</h2>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li>By opting in, you consent to receive non-marketing SMS messages including event reminders and assistant responses.</li>
          <li>Message frequency varies based on the number of contacts and events you track.</li>
          <li>Message and data rates may apply depending on your mobile carrier.</li>
          <li>Reply <strong>STOP</strong> at any time to unsubscribe from SMS messages.</li>
          <li>Reply <strong>HELP</strong> for assistance.</li>
        </ul>

        <h2 style={{ color: '#5D4037', fontSize: '1.15rem', marginTop: '2rem' }}>User Responsibilities</h2>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li>You are responsible for providing accurate contact information.</li>
          <li>You agree not to use the service for any unlawful purpose.</li>
          <li>You are responsible for the data you enter, including contacts' names and dates.</li>
        </ul>

        <h2 style={{ color: '#5D4037', fontSize: '1.15rem', marginTop: '2rem' }}>Limitation of Liability</h2>
        <p>String is provided "as is" without warranties of any kind. We are not liable for missed reminders, delivery failures, or any damages resulting from use of the service.</p>

        <h2 style={{ color: '#5D4037', fontSize: '1.15rem', marginTop: '2rem' }}>Termination</h2>
        <p>You may stop using the service at any time. We reserve the right to suspend or terminate accounts that violate these terms.</p>

        <h2 style={{ color: '#5D4037', fontSize: '1.15rem', marginTop: '2rem' }}>Changes</h2>
        <p>We may update these terms from time to time. Continued use of the service constitutes acceptance of any changes.</p>

        <p style={{ marginTop: '2rem' }}>
          <strong style={{ color: '#5D4037' }}>Contact:</strong>{' '}
          <a href="mailto:reminders@stringapp.co" style={{ color: '#6B7F5E' }}>reminders@stringapp.co</a>
        </p>
      </section>

      <footer className="landing-footer" style={{ marginTop: '3rem' }}>
        <p>Like tying a string around your finger.</p>
      </footer>
    </div>
  );
}
